import { BLOCK_TYPES } from '../../database/news';

const NewsRenderer = ({ blocks = [] }) => {
  if (!blocks.length) {
    return <p className="text-sm text-muted-foreground">No content.</p>;
  }

  return (
    <div className="news-body space-y-6">
      {blocks.map((b) => {
        if (b.type === BLOCK_TYPES.IMAGE) {
          if (!b.url) return null;
          return (
            <figure key={b.id} className="space-y-2">
              <img
                src={b.url}
                alt={b.alt || ''}
                className="w-full rounded-md border border-border/60 object-cover"
              />
              {b.caption && (
                <figcaption className="text-center font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
                  {b.caption}
                </figcaption>
              )}
            </figure>
          );
        }
        // text block — trusted HTML from Tiptap (content admin authored)
        return (
          <div
            key={b.id}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: b.html || '' }}
          />
        );
      })}
    </div>
  );
};

export default NewsRenderer;
